import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ButtonsModule, KENDO_BUTTONS } from '@progress/kendo-angular-buttons';
import { IndicatorsModule } from '@progress/kendo-angular-indicators';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { NavigationModule } from '@progress/kendo-angular-navigation';
import { LoggerService } from '../../shared/logger.service';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { all } from '@awesome.me/kit-787edf9aa0/icons';
import { Subscription } from 'rxjs';
import { MenusModule } from '@progress/kendo-angular-menu';
import { TileItem } from '../../common/obj.lib';

const defaultMenuItems: any[] = [
  { text: "Select All" },
  // { text: "Clone panel" },
  // { text: "Expand all iterations" },
  // { text: "Collapse all iterations" },
  // { text: "Hide empty iterations" },
  // { text: "Split Current iteration and Backlog" },
  // { text: "Add stories to bottom of panel" }
]

@Component({
  selector: 'casi-tile-header',
  standalone: true,
  imports: [
    CommonModule,
    LayoutModule,
    ButtonsModule,
    IndicatorsModule,
    NavigationModule,
    FontAwesomeModule,
    MenusModule,
    KENDO_BUTTONS
  ],
  templateUrl: './casi-tile-header.component.html',
  styleUrl: './casi-tile-header.component.scss'
})
export class CasiTileHeaderComponent implements OnInit, OnDestroy {

  private _tile: TileItem | undefined;
  @Input({ required: true })
  set tile(value: TileItem) {
    this._tile = value;
  }
  get tile() {
    return this._tile!;
  }

  // private _menuContext: any[] = [];
  // @Input({required: true})
  // set menuContext(val: any[]) {
  //   if (val.length > 0)
  //     this._menuContext = val;
  //   else {
  //     this._menuContext = defaultMenuItems
  //   }
  // }
  // get menuContext() {
  //   return this._menuContext;
  // }

  @Output() onCloseTile = new EventEmitter<TileItem>();

  @Output() onAddTile = new EventEmitter<TileItem>();
  @Output() onShowMenu = new EventEmitter<TileItem>();

  public popupClass = "font-arial";

  private _subs: Subscription[] = [];

  constructor(
    private logger: LoggerService,
    public faIcons: FaIconLibrary,
  ) {
    faIcons.addIcons(...all);
  }

  //#region NG Event Handlers
  ngOnInit(): void {
    this.logger.debug('ngOnInit...');
  }

  ngOnDestroy(): void {
    this.logger.debug('ngOnDestroy...');
    this._subs.forEach(s => s.unsubscribe());
  }

  //#endregion

  public closeTile(tile: TileItem) {
    this.logger.debug(`closeTile: `, tile.name);
    this.onCloseTile.emit(tile);
  }

  public addItem(tile: TileItem) {
    this.logger.debug(`addItem: `, tile.name);
    this.onAddTile.emit(tile);
  }

  public onItemClick(action: any) {
    this.logger.debug(`onItemClick: `, action);
    this.onShowMenu.emit(this.tile);
  }

}
